import React, { Component } from 'react';
import { ProgressBarContainer, ProgressBarStyle, JourneySummary } from '../styles/progress_bar_styles';

export default class ProgressBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nav_selection: props.nav_selection,
      hotel_favs: props.data.hotel_favs,
      attraction_favs: props.data.attraction_favs,
      restaurant_favs: props.data.restaurant_favs
    }
    this.onClick = this.onClick.bind(this)
    this.displayProgressBar = this.displayProgressBar.bind(this)
  }

  UNSAFE_componentWillReceiveProps(props){
    var hotel_favs = props.data.hotel_favs
    var attraction_favs= props.data.attraction_favs
    var restaurant_favs= props.data.restaurant_favs
    var nav_selection = props.nav_selection

    this.setState(
      {
        hotel_favs: hotel_favs,
        attraction_favs: attraction_favs,
        restaurant_favs: restaurant_favs,
        nav_selection: nav_selection

      },
      ()=> {console.log(this.state.nav_selection, this.state.hotel_favs, this.state.restaurant_favs, this.state.attraction_favs)}
    )
  }

  onClick(){
    this.props.seeWholeJourney('whole_journey')
  }

  displayProgressBar(){
    var hotel_cnt = this.state.hotel_favs.length
    var restaurant_cnt = this.state.restaurant_favs.length
    var attractions_cnt = this.state.attraction_favs.length
    if(this.state.nav_selection === "whole_journey"){
      return
    }
    return (
      <ProgressBarStyle>
        <JourneySummary> You have {hotel_cnt} hotels, {attractions_cnt} attractions, and {restaurant_cnt} restaurants in your journey. </JourneySummary>
      </ProgressBarStyle>
    )
  }

  render() {
    const progBar = this.displayProgressBar()
    return(
      <ProgressBarContainer>
        {progBar}
      </ProgressBarContainer>
    )
  }
}
